(function ($) {
    $(function () {

        if ($('.js-template--single-article').length) {

            function updatePostViews(postId) {
                var data = {
                    action: 'update_post_views',
                    post_id: postId
                };

                $.post(localize.ajaxurl, data, function (response) {

                    console.log('Post views updated!');
                });
            }

            var currentPostId = $('.js-template--single-article').data('id');
            updatePostViews(currentPostId);
        }
    });
})(jQuery);